// Mock data for Artourius Design products

export const productCategories = [
  {
    id: 'sculpture',
    name: 'SCULPTURE',
    slug: 'sculpture'
  },
  {
    id: 'birdcage',
    name: 'BIRD CAGE LIGHTNINGS',
    slug: 'bird-cage-lightnings'
  },
  {
    id: 'unique',
    name: 'UNIQUE PIECES',
    slug: 'unique-pieces'
  },
  {
    id: 'diamond-sculptures',
    name: 'Diamond Sculptures',
    slug: 'diamond-sculptures'
  },
  {
    id: 'coffee-tables',
    name: 'Coffee Tables',
    slug: 'coffee-tables'
  },
  {
    id: 'mixed-art',
    name: 'Mixed Art Pieces',
    slug: 'mixed-art-pieces'
  }
];

// Collections for landing page showcase
export const collections = [
  {
    id: 'diamond-sculptures',
    name: 'Diamond Sculptures',
    slug: 'diamond-sculptures',
    description: 'Exquisite diamond-inspired artistry combining luxury materials with timeless design',
    image: 'https://images.unsplash.com/photo-1610701596007-11502861dcfa?w=800&h=600&fit=crop',
    itemCount: 'Coming Soon'
  },
  {
    id: 'coffee-tables',
    name: 'Coffee Tables',
    slug: 'coffee-tables',
    description: 'Functional luxury centerpieces that transform your living space',
    image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&h=600&fit=crop',
    itemCount: 'Coming Soon'
  },
  {
    id: 'mixed-art',
    name: 'Mixed Art Pieces',
    slug: 'mixed-art-pieces',
    description: 'Eclectic creative expressions blending various mediums and styles',
    image: 'https://images.unsplash.com/photo-1513519245088-0e12902e35ca?w=800&h=600&fit=crop',
    itemCount: 'Coming Soon'
  }
];

export const featuredProducts = [
  {
    id: 1,
    title: 'Golden Eagle Sculpture',
    category: 'sculpture',
    description: 'Majestic golden eagle crafted with precision and detail',
    image: 'https://images.unsplash.com/photo-1564733071106-7a0737c8b3df?w=800&h=600&fit=crop',
    price: 2500,
    material: 'Bronze with gold plating',
    dimensions: '45cm x 30cm x 25cm',
    tags: ['sculpture', 'luxury', 'limited']
  },
  {
    id: 2,
    title: 'Vintage Bird Cage Pendant',
    category: 'birdcage',
    description: 'Elegant bird cage lighting with intricate metalwork',
    image: 'https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?w=800&h=600&fit=crop',
    price: 1800,
    material: 'Brass with LED lighting',
    dimensions: '35cm x 35cm x 50cm',
    tags: ['lighting', 'vintage', 'handcrafted']
  },
  {
    id: 3,
    title: 'Abstract Modern Piece',
    category: 'unique',
    description: 'One-of-a-kind abstract sculpture in gold finish',
    image: 'https://images.unsplash.com/photo-1582738411706-bfc8e691d1c2?w=800&h=600&fit=crop',
    price: 3200,
    material: 'Mixed metals, gold leaf',
    dimensions: '60cm x 40cm x 35cm',
    tags: ['unique', 'modern', 'exclusive']
  },
  {
    id: 4,
    title: 'Classical Greek Inspired',
    category: 'sculpture',
    description: 'Timeless beauty inspired by ancient Greek art',
    image: 'https://images.unsplash.com/photo-1578321272176-b7bbc0679853?w=800&h=600&fit=crop',
    price: 2800,
    material: 'Marble and bronze',
    dimensions: '55cm x 25cm x 20cm',
    tags: ['sculpture', 'classical', 'elegant']
  },
  {
    id: 5,
    title: 'Crystal Bird Cage Light',
    category: 'birdcage',
    description: 'Luxurious crystal adorned bird cage lighting',
    image: 'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=800&h=600&fit=crop',
    price: 2100,
    material: 'Crystal and brass',
    dimensions: '40cm x 40cm x 60cm',
    tags: ['lighting', 'luxury', 'crystal']
  },
  {
    id: 6,
    title: 'Artisan Wall Sculpture',
    category: 'unique',
    description: 'Handcrafted wall-mounted artistic statement',
    image: 'https://images.unsplash.com/photo-1561214115-f2f134cc4912?w=800&h=600&fit=crop',
    price: 1900,
    material: 'Mixed metals and wood',
    dimensions: '80cm x 60cm x 15cm',
    tags: ['unique', 'wall-art', 'contemporary']
  },
  {
    id: 7,
    title: 'Lion Statement Piece',
    category: 'sculpture',
    description: 'Powerful lion sculpture symbolizing strength',
    image: 'https://images.unsplash.com/photo-1550355191-aa8a80b41353?w=800&h=600&fit=crop',
    price: 3500,
    material: 'Bronze with patina finish',
    dimensions: '50cm x 35cm x 40cm',
    tags: ['sculpture', 'statement', 'bold']
  },
  {
    id: 8,
    title: 'Minimalist Cage Chandelier',
    category: 'birdcage',
    description: 'Modern minimalist interpretation of classic design',
    image: 'https://images.unsplash.com/photo-1524484485831-a92ffc0de03f?w=800&h=600&fit=crop',
    price: 2400,
    material: 'Steel and glass',
    dimensions: '45cm x 45cm x 70cm',
    tags: ['lighting', 'minimalist', 'modern']
  },
  {
    id: 9,
    title: 'Geometric Gold Sculpture',
    category: 'unique',
    description: 'Contemporary geometric design in luxurious gold',
    image: 'https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=800&h=600&fit=crop',
    price: 2700,
    material: 'Aluminum with gold plating',
    dimensions: '40cm x 40cm x 50cm',
    tags: ['unique', 'geometric', 'contemporary']
  }
];

export const shippingOptions = [
  {
    id: 'standard',
    name: 'Standard Shipping',
    description: 'DHL, UPS, Swiss Post',
    price: 50,
    duration: '5-7 business days'
  },
  {
    id: 'pickup',
    name: 'Self Pick-up',
    description: 'Collect from our showroom',
    price: 0,
    duration: 'Flexible'
  },
  {
    id: 'vip',
    name: 'VIP White Glove Service',
    description: 'Professional delivery and installation',
    price: 200,
    duration: 'Scheduled appointment'
  }
];